var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticStyle: { width: "100%" } },
    [
      _c(
        "el-col",
        [
          _c(
            "el-form",
            {
              ref: "labelForm",
              attrs: {
                model: _vm.labelForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.showProperty("show"),
                      expression: "showProperty('show')",
                    },
                  ],
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeLabelAttr("show")
                        },
                      },
                      model: {
                        value: _vm.labelForm.show,
                        callback: function ($$v) {
                          _vm.$set(_vm.labelForm, "show", $$v)
                        },
                        expression: "labelForm.show",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.labelForm.show,
                      expression: "labelForm.show",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("labelContent"),
                          expression: "showProperty('labelContent')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.label_content") },
                    },
                    [
                      _c(
                        "el-checkbox-group",
                        {
                          attrs: {
                            label: _vm.$t("chart.label_content"),
                            min: 1,
                            max: 3,
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("labelContent")
                            },
                          },
                          model: {
                            value: _vm.labelForm.labelContent,
                            callback: function ($$v) {
                              _vm.$set(_vm.labelForm, "labelContent", $$v)
                            },
                            expression: "labelForm.labelContent",
                          },
                        },
                        _vm._l(_vm.labelContentOptions, function (option) {
                          return _c(
                            "el-checkbox",
                            {
                              key: option.value,
                              attrs: { label: option.value },
                            },
                            [_vm._v(_vm._s(option.name))]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("fontSize"),
                          expression: "showProperty('fontSize')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_fontsize") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.text_fontsize"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("fontSize")
                            },
                          },
                          model: {
                            value: _vm.labelForm.fontSize,
                            callback: function ($$v) {
                              _vm.$set(_vm.labelForm, "fontSize", $$v)
                            },
                            expression: "labelForm.fontSize",
                          },
                        },
                        _vm._l(_vm.fontSize, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("color"),
                          expression: "showProperty('color')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeLabelAttr("color")
                          },
                        },
                        model: {
                          value: _vm.labelForm.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.labelForm, "color", $$v)
                          },
                          expression: "labelForm.color",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("position-v"),
                          expression: "showProperty('position-v')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.label_position") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.label_position"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("position")
                            },
                          },
                          model: {
                            value: _vm.labelForm.position,
                            callback: function ($$v) {
                              _vm.$set(_vm.labelForm, "position", $$v)
                            },
                            expression: "labelForm.position",
                          },
                        },
                        _vm._l(_vm.labelPositionV, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("position-pie"),
                          expression: "showProperty('position-pie')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.label_position") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.label_position"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("position")
                            },
                          },
                          model: {
                            value: _vm.labelForm.position,
                            callback: function ($$v) {
                              _vm.$set(_vm.labelForm, "position", $$v)
                            },
                            expression: "labelForm.position",
                          },
                        },
                        _vm._l(_vm.labelPositionPie, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.showProperty("position-h"),
                          expression: "showProperty('position-h')",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.label_position") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.label_position"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("position")
                            },
                          },
                          model: {
                            value: _vm.labelForm.position,
                            callback: function ($$v) {
                              _vm.$set(_vm.labelForm, "position", $$v)
                            },
                            expression: "labelForm.position",
                          },
                        },
                        _vm._l(_vm.labelPositionH, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.showProperty("reserveDecimalCount") &&
                            (_vm.chart.type.includes("percentage") ||
                              _vm.labelForm.labelContent.includes(
                                "proportion"
                              )),
                          expression:
                            "showProperty('reserveDecimalCount') && (chart.type.includes('percentage') || labelForm.labelContent.includes('proportion'))",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: {
                        label: _vm.$t("chart.label_reserve_decimal_count"),
                      },
                    },
                    [
                      _c(
                        "el-radio-group",
                        {
                          attrs: {
                            label: _vm.$t("chart.label_reserve_decimal_count"),
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("reserveDecimalCount")
                            },
                          },
                          model: {
                            value: _vm.labelForm.reserveDecimalCount,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.labelForm,
                                "reserveDecimalCount",
                                $$v
                              )
                            },
                            expression: "labelForm.reserveDecimalCount",
                          },
                        },
                        _vm._l(
                          _vm.reserveDecimalCountOptions,
                          function (option) {
                            return _c(
                              "el-radio",
                              {
                                key: option.value,
                                attrs: { label: option.value },
                              },
                              [_vm._v(_vm._s(option.name))]
                            )
                          }
                        ),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "el-form",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value:
                    _vm.showProperty("labelGauge") &&
                    _vm.chart.type &&
                    (_vm.chart.type.includes("gauge") ||
                      _vm.chart.type.includes("liquid")),
                  expression:
                    "showProperty('labelGauge') && chart.type && (chart.type.includes('gauge') || chart.type.includes('liquid'))",
                },
              ],
              ref: "labelForm",
              attrs: {
                model: _vm.labelForm,
                "label-width": "80px",
                size: "mini",
              },
            },
            [
              _c(
                "el-form-item",
                {
                  staticClass: "form-item",
                  attrs: { label: _vm.$t("chart.show") },
                },
                [
                  _c(
                    "el-checkbox",
                    {
                      on: {
                        change: function ($event) {
                          return _vm.changeLabelAttr("show")
                        },
                      },
                      model: {
                        value: _vm.labelForm.show,
                        callback: function ($$v) {
                          _vm.$set(_vm.labelForm, "show", $$v)
                        },
                        expression: "labelForm.show",
                      },
                    },
                    [_vm._v(_vm._s(_vm.$t("chart.show")))]
                  ),
                ],
                1
              ),
              _c(
                "div",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.labelForm.show,
                      expression: "labelForm.show",
                    },
                  ],
                },
                [
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_fontsize") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.text_fontsize"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("fontSize")
                            },
                          },
                          model: {
                            value: _vm.labelForm.fontSize,
                            callback: function ($$v) {
                              _vm.$set(_vm.labelForm, "fontSize", $$v)
                            },
                            expression: "labelForm.fontSize",
                          },
                        },
                        _vm._l(_vm.fontSize, function (option) {
                          return _c("el-option", {
                            key: option.value,
                            attrs: { label: option.name, value: option.value },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.text_color") },
                    },
                    [
                      _c("el-color-picker", {
                        staticClass: "color-picker-style",
                        attrs: { predefine: _vm.predefineColors },
                        on: {
                          change: function ($event) {
                            return _vm.changeLabelAttr("color")
                          },
                        },
                        model: {
                          value: _vm.labelForm.color,
                          callback: function ($$v) {
                            _vm.$set(_vm.labelForm, "color", $$v)
                          },
                          expression: "labelForm.color",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.value_formatter_type") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("gaugeLabelFormatter")
                            },
                          },
                          model: {
                            value: _vm.labelForm.gaugeLabelFormatter.type,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.labelForm.gaugeLabelFormatter,
                                "type",
                                $$v
                              )
                            },
                            expression: "labelForm.gaugeLabelFormatter.type",
                          },
                        },
                        _vm._l(_vm.typeList, function (type) {
                          return _c("el-option", {
                            key: type.value,
                            attrs: {
                              label: _vm.$t("chart." + type.name),
                              value: type.value,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.labelForm.gaugeLabelFormatter.type !== "auto",
                          expression:
                            "labelForm.gaugeLabelFormatter.type !== 'auto'",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: {
                        label: _vm.$t("chart.value_formatter_decimal_count"),
                      },
                    },
                    [
                      _c("el-input-number", {
                        attrs: { precision: 0, min: 0, max: 10, size: "mini" },
                        on: {
                          change: function ($event) {
                            return _vm.changeLabelAttr("gaugeLabelFormatter")
                          },
                        },
                        model: {
                          value: _vm.labelForm.gaugeLabelFormatter.decimalCount,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.labelForm.gaugeLabelFormatter,
                              "decimalCount",
                              $$v
                            )
                          },
                          expression:
                            "labelForm.gaugeLabelFormatter.decimalCount",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value:
                            _vm.labelForm.gaugeLabelFormatter.type !==
                            "percent",
                          expression:
                            "labelForm.gaugeLabelFormatter.type !== 'percent'",
                        },
                      ],
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.value_formatter_unit") },
                    },
                    [
                      _c(
                        "el-select",
                        {
                          attrs: {
                            placeholder: _vm.$t("chart.pls_select_field"),
                            size: "mini",
                          },
                          on: {
                            change: function ($event) {
                              return _vm.changeLabelAttr("gaugeLabelFormatter")
                            },
                          },
                          model: {
                            value: _vm.labelForm.gaugeLabelFormatter.unit,
                            callback: function ($$v) {
                              _vm.$set(
                                _vm.labelForm.gaugeLabelFormatter,
                                "unit",
                                $$v
                              )
                            },
                            expression: "labelForm.gaugeLabelFormatter.unit",
                          },
                        },
                        _vm._l(_vm.unitList, function (item) {
                          return _c("el-option", {
                            key: item.value,
                            attrs: {
                              label: _vm.$t("chart." + item.name),
                              value: item.value,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: { label: _vm.$t("chart.value_formatter_suffix") },
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          size: "mini",
                          clearable: "",
                          placeholder: _vm.$t("commons.input_content"),
                        },
                        on: {
                          change: function ($event) {
                            return _vm.changeLabelAttr("gaugeLabelFormatter")
                          },
                        },
                        model: {
                          value: _vm.labelForm.gaugeLabelFormatter.suffix,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.labelForm.gaugeLabelFormatter,
                              "suffix",
                              $$v
                            )
                          },
                          expression: "labelForm.gaugeLabelFormatter.suffix",
                        },
                      }),
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      staticClass: "form-item",
                      attrs: {
                        label: _vm.$t(
                          "chart.value_formatter_thousand_separator"
                        ),
                      },
                    },
                    [
                      _c("el-checkbox", {
                        on: {
                          change: function ($event) {
                            return _vm.changeLabelAttr("gaugeLabelFormatter")
                          },
                        },
                        model: {
                          value:
                            _vm.labelForm.gaugeLabelFormatter.thousandSeparator,
                          callback: function ($$v) {
                            _vm.$set(
                              _vm.labelForm.gaugeLabelFormatter,
                              "thousandSeparator",
                              $$v
                            )
                          },
                          expression:
                            "labelForm.gaugeLabelFormatter.thousandSeparator",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }